import _ from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'

const mixin =
{
    data ()
    {
        return {
            ready: false
        }
    },

    props:
    {
        channel:
        {
            required: true
        },

        chatStates:
        {
            required: false,
            default: []
        }
    },

    computed:
    {
        ...mapState({
            user: ({ current }) => current.user
        }),

        lastParticipant()
        {
            try
            {
                return this.lastChannel.lastChat.user.name
            }
            catch (e)
            {
                return '';
            }
        },

        lastChannel()
        {
            let last = _.last(this.unreadChats);

            if (typeof last !== 'undefined') return last.channel;
            return this.channel;
        },

        unreadCount()
        {
            return _.size(this.unreadChats);
        },

        unreadChats()
        {
            return _.filter(this.chatStates, {
                'channel':
                {
                    'id': this.channel.id
                }
            })
        }
    },

    methods:
    {
        refreshUnreadChats(unreadChats, channelId)
        {
            let ids = _.map(_.filter(unreadChats, chat => chat.readAt === null && chat.channel.id === channelId), item => item.statusId);

            if ( ! ids.length) return;

            this.$http.silent().put('/api/memberships/unread-chats',
            {
                ids: ids,
                status: 'read',
                channel: channelId
            }).then(response =>
            {
                this.$store.commit('chat/SET_UNREAD_CHATS', response.data, { root: true })
            });
        },

        dateFormat(format, date)
        {
            return moment(date, format).calendar(null, {
                sameDay: 'HH:mm',
                lastDay: '[Yesterday]',
                lastWeek: 'dddd',
                sameElse: 'DD. MMMM YYYY'
            })
        }
    }
}

export default mixin;
export let computed = { computed: mixin.computed };
export let methods = { methods: mixin.methods };



// WEBPACK FOOTER //
// ./src/js/helpers/channelChat.js